import styled from 'styled-components';
import colors from 'theme/colors';

export const PackagesTableStyles = styled.section`
  .ant-table-expanded-row .ant-table-cell {
    background: ${colors.background};
  }

  .ant-table-row:hover {
    cursor: pointer;
  }

  .ant-card {
    height: 100%;
  }

  .hidden {
    padding: 0;
    display: none;
  }

  .ant-table-footer {
    display: flex;
    justify-content: end;
    padding-bottom: 0;
    padding-top: 0;
    background-color: transparent;
  }
`;
